<template>
  <div class="box signup_bg">
    <div class="wrap w1050" style="width: 1100px;">
      <div class="train_title_detail">
        <dl>
          <dt>{{form.title}}</dt>
          <dd>{{form.updateDate}}</dd>
        </dl>
      </div>
      <!--信息详情-->
      <div class="train_info_detail" v-html="form.content"></div>
      <!--/信息详情-->
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        form: {}
      }
    },
    created () {
      this.getModel(this.$route.params.id)
    },
    methods: {
      getModel (id) {
        var that = this
        this.$api.post(this.$global.bylBaseCenterPath, '/noticeinfo/get', { id: id }, function (r) { // 正常
          that.form = r.data
          // that.$emit('data-prepared', that.form)
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/continueEdu/train/model.vue